(function () {
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function isValidEmail(value) {
    return EMAIL_RE.test((value || '').trim());
  }

  function initComingSoon(root) {
    if (!root) return;
    var form = root.querySelector('.coming-soon__form');
    if (!form || form.dataset.csBound) return;
    form.dataset.csBound = 'true';

    var input = form.querySelector('.coming-soon__input');
    var button = form.querySelector('[data-cs-submit]');
    var error = form.querySelector('[data-cs-error]');
    var intro = root.querySelector('[data-cs-intro]');
    var success = root.querySelector('[data-cs-success]');

    function refreshButton() {
      button.disabled = !isValidEmail(input.value);
    }

    function showError(message) {
      if (!error) return;
      error.textContent = message;
      error.hidden = false;
    }

    function clearError() {
      if (!error) return;
      error.hidden = true;
      error.textContent = '';
    }

    function showSuccess() {
      if (intro) intro.hidden = true;
      if (success) success.hidden = false;
    }

    input.addEventListener('input', refreshButton);
    refreshButton();

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var email = input.value.trim();
      if (!isValidEmail(email)) {
        refreshButton();
        return;
      }

      clearError();

      var key = (form.dataset.klaviyoKey || '').trim();
      var list = (form.dataset.klaviyoList || '').trim();

      // Klaviyo not connected yet: demonstrate the success flow for the preview
      // without sending anything. Goes live the moment a key + list are entered.
      if (!key || !list) {
        if (window.console && console.warn) {
          console.warn('[coming-soon] Klaviyo is not configured (missing Public API Key or List ID). Showing the success state for preview only — no email was sent.');
        }
        showSuccess();
        return;
      }

      button.disabled = true;
      var revision = (form.dataset.klaviyoRevision || '').trim() || '2025-07-15';
      var source = (form.dataset.klaviyoSource || '').trim() || 'Coming Soon Page';

      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: source,
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                }
              }
            }
          },
          relationships: {
            list: { data: { type: 'list', id: list } }
          }
        }
      };

      fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(key), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          revision: revision
        },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          if (response.status === 202) {
            showSuccess();
            return;
          }
          return response.text().then(function (body) {
            if (window.console && console.error) {
              console.error('[coming-soon] Klaviyo subscribe failed', response.status, body);
            }
            showError('Something went wrong. Please try again.');
            button.disabled = false;
          });
        })
        .catch(function (err) {
          if (window.console && console.error) {
            console.error('[coming-soon] Klaviyo request error', err);
          }
          showError('Something went wrong. Please try again.');
          button.disabled = false;
        });
    });
  }

  function initAll() {
    var nodes = document.querySelectorAll('.coming-soon');
    for (var i = 0; i < nodes.length; i++) {
      initComingSoon(nodes[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor: re-bind when the section is re-rendered.
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector ? event.target.querySelector('.coming-soon') : null;
    initComingSoon(root);
  });
})();
